module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/UnitPreview/images/unitPreviewBackground.4e73083b.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/UnitPreview/images/unitPreviewBackground.jpg
// module id = 2756
// module chunks = 11